import WizardHeader from '@/js/configuration-wizard/components/atoms/WizardHeader/WizardHeader';

export default WizardHeader;
